import { useEffect } from 'react';

import HeaderExtra from '../components/HeaderExtra'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import '../Assets/css/rangeslider.css'
import '../Assets/css/datepicker.css'

// import  '../Assets/js/datetimefunc.js'
import  '../Assets/js/myping.js'

function MyPing()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("MyPing");
  }, []);

  return (
    <>
      <div className="basic">

        <HeaderExtra page="My Ping"/>

        <div className="MainContentSection PaddingLeftRightForSafari">
          <div className="MainSectionBasicWithBlue">
            <div className="FilterRightSection" style={{marginLeft:"0"}}>
              <div className="SectionSeparatorContainer SectionSeparatorContainerShortenBottom" style={{paddingTop:"0"}}>
                <div className="SectionContentWrapper" style={{width:"100%"}}>
                  <p className="SectionHeaderTextIndex2 InterBoldTextFont" id="PingOnGoingHeaderText">Ping Ongoing</p>
                  <div className="NoFeaturedPropertyFoundContainer" id="PingOnGoingNotFoundContainer" style={{display:"none"}}>
                    <img src="/Assets/images/ButtonIcon/no-featured.svg" className="NoFoundIcon" />
                    <div className="InputFieldMargin3" style={{WebkitFlexDirection:"column", msFlexDirection:"column",flexDirection:"column"}}>
                      <p className="NoFoundHeaderText InterBoldTextFont" id="NoPingOnGoingHeaderText">No Ping Ongoing</p>
                      <p className="NoFoundMessageText InterRegularTextFont" id="NoPingOnGoingMessageText">No hotel ping yet, explore hotel and make a ping</p>
                    </div>
                    <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable" style={{margin:"0 auto"}} id="ExploreButton">Explore</button>
                  </div>
                  <div className="SearchResultPanelContainer" id="OnGoingPingPanelContainer">

                  </div>
                  <div id='whichOnGoingSentinel'></div>
                </div>
              </div>
              <div className="SectionSeparatorContainer SectionSeparatorContainerShortenBottom" style={{paddingTop:"0",display:"none"}} id="PastPingMainContent">
                <div className="SectionContentWrapper" style={{width:"100%"}}>
                  <p className="SectionHeaderTextIndex2 InterBoldTextFont" id="PastPingHeaderText">Past Ping</p>
                  <div className="SearchResultPanelContainer" id="PastPingPanelContainer">
                  </div>
                  <div id='whichPastSentinel'></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <RightPanelMobile/>
      <Footer/>
    </>
  )
}

export default MyPing